import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './tariff.reducer';

export const Tariff = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const tariffList = useAppSelector(state => state.tariff.entities);
  const loading = useAppSelector(state => state.tariff.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tariff-heading" data-cy="TariffHeading">
        <Translate contentKey="crawlerBackendApp.tariff.home.title">Tariffs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.tariff.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/tariff/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.tariff.home.createLabel">Create new Tariff</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {tariffList && tariffList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.tariff.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('type')}>
                  <Translate contentKey="crawlerBackendApp.tariff.type">Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('type')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.tariff.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('isFixedTariff')}>
                  <Translate contentKey="crawlerBackendApp.tariff.isFixedTariff">Is Fixed Tariff</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isFixedTariff')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.tariff.productOfferingPrice">
                    Product Offering Price
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tariffList.map((tariff, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/tariff/${tariff.id}`} color="link" size="sm">
                      {tariff.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.TariffType.${tariff.type}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${tariff.productType}`} />
                  </td>
                  <td>{tariff.isFixedTariff ? 'true' : 'false'}</td>
                  <td>
                    {tariff.productOfferingPrices
                      ? tariff.productOfferingPrices.map((val, j) => (
                          <span key={j}>
                            <Link to={`/product-offering-price/${val.id}`}>{val.id}</Link>
                            {j === tariff.productOfferingPrices.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tariff/${tariff.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tariff/${tariff.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/tariff/${tariff.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.tariff.home.notFound">No Tariffs found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Tariff;
